import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-school",
  "use": "icon-school-usage",
  "viewBox": "0 0 48 48",
  "content": "<symbol viewBox=\"0 0 48 48\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-school\"><path d=\"M23.9693 39.6921L10.604 32.3768V21.5307L4.07706 18L23.9693 7.15393L43.9229 18V32.2729H41.6538V19.3269L37.3346 21.5307V32.3768L23.9693 39.6921ZM23.9693 26.273L39.1423 18L23.9693 9.83848L8.85776 18L23.9693 26.273ZM23.9693 37.1191L35.0654 31.0191V22.9076L23.9693 28.846L12.8731 22.8268V31.0191L23.9693 37.1191Z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol